module.exports = __webpack_public_path__ + "img/colaboracion.2ff78983.png";